const layoutJS = {
  quantityHandler(el, add, page, area, price) {
    var $product_number = $(el).siblings('.product_number')
    var willReturn = $product_number.hasClass('disabled')
    if (willReturn) return
    var currentVal = Number($product_number.val())
    var newQuantity = currentVal + Number(add)
    var max = Number($product_number.attr('max'));
    var finalQ = newQuantity <= 0 ? 0 : newQuantity >= max ? max : newQuantity
    $product_number.val(finalQ)

    // 任選N件func
    if (page === 'N') {
      if(newQuantity > max) return;
      ListJS.productNHandle({ el: el, add: add, finalQ: finalQ })
    }
    // 紅配綠func
    if (page === 'pair') {
      if (currentVal === 0 && add === -1) return;
      if(newQuantity > max) return;
      ListJS.productPairHandle({ add: add, area: area, price: price })
    }
  },
  checkHandler(el, area, price) {
    var willBuy = $(el).prop('checked')
    var $product_number = $(el)
      .parent('.check_area')
      .siblings('.product_number_count_group')
      .find('.product_number')
    var minus = Number($product_number.val())
    if (willBuy) {
      $product_number.removeClass('disabled')
    } else {
      $product_number.addClass('disabled').val(0)
      ListJS.productPairHandle({
        add: -minus,
        area: area,
        price: price,
      })
    }
  },
  Scrollr({ dom, reset, distance }) {
    var setting = {
      distance: distance || '50px',
      duration: 1000,
      delay: 600,
      interval: 500,
      reset,
    }
    ScrollReveal().reveal(dom, setting)
  },
  counterInactive({ dom }) {
    var setting = {
      distance: '0px',
      duration: 0,
      delay: 0,
      opacity: 1,
      reset: false,
      afterReveal: function (el) {
        const number = Number($(el).attr('data-counter'))
        const index = Number($(el).attr('data-index'))
        const from = Number($(el).attr('data-from'))
        layoutJS.counterFun(el, number, index, from)
      },
    }
    ScrollReveal().reveal(dom, setting)
  },
  counterFun(el, maxNumber, index, from) {
    var count = from || 0
    function myCount() {
      if (count > maxNumber) {
        return false
      }
      $(el)
        .find('p')
        .text(count < 10 ? `0${count}` : count)
      count++
    }
    setTimeout(() => {
      setInterval(myCount, 60)
    }, index * 600)
  },
  counterDate(endDate) {
    var _second = 1000
    var _minute = _second * 60
    var _hour = _minute * 60
    var _day = _hour * 24
    var timer
    $('#countdown').html(
      '<div id="day"></div><div id="hour"></div><div id="minute"></div><div id="sec"></div>'
    )
    function showRemaining() {
      var now = new Date()
      var distance = endDate - now
      if (distance < 0) {
        clearInterval(timer)
        $('#countdown').hide()
        return
      }
      var days = Math.floor(distance / _day)
      var hours = Math.floor((distance % _day) / _hour)
      var minutes = Math.floor((distance % _hour) / _minute)
      var seconds = Math.floor((distance % _minute) / _second)

      $('#day').html(days < 10 ? `0${days}` : days)
      $('#hour').html(hours < 10 ? `0${hours}` : hours)
      $('#minute').html(minutes < 10 ? `0${minutes}` : minutes)
      $('#sec').html(seconds < 10 ? `0${seconds}` : seconds)
    }

    timer = setInterval(showRemaining, 1000)
  },
  menu_active: false,
  mobileMenuHandler() {
    $('body').on('click', '.navbar, .banner>i', () => {
      $('.navbar, .dropMenu, .dropMenuBg, .banner>i').toggleClass('open')
      $('.search').removeClass('show')
    })
    $('body').on('click', '.dropMenuBg', () => {
      $('.navbar, .dropMenu, .dropMenuBg, .banner>i').removeClass('open')
      $('.search').removeClass('show')
    })
  },
  mainSlick(el, callback) {
    $(el).slick({
      arrows: true,
      dots: true,
      infinite: true,
      speed: 800,
      slidesToShow: 1,
      autoplay: true,
      autoplaySpeed: 3000,
    })

    callback
  },
  regularSlick({ el, callback, slidesToShow, extraSetting, slidesToScroll }) {
    $(el).slick({
      arrows: true,
      slidesToScroll: slidesToScroll || 1,
      slidesToShow: slidesToShow || 3,
      infinite: false,
      speed: 800,
      ...extraSetting,
    })

    callback
  },
  setLayout() {
    $('.header').load('../_components/_layout.html #header')
    $('.footer').load('../_components/_layout.html #footer')
  },
  goToTopHandler() {
    var $body = window.opera
      ? document.compatMode == 'CSS1Compat'
        ? $('html')
        : $('body')
      : $('html,body')
    $('body').on('click', '.goToTop', () => {
      $body.animate({ scrollTop: 0 }, 600)
    })
  },
  isMobile() {
    return $(window).innerWidth() < 600
  },
  mobileDetectDirect() {
    // var lastScrollTop = 0
    // window.addEventListener(
    //   'scroll',
    //   function () {
    //     if ($(window).scrollTop() < 10) {
    //       $('.search').removeClass('show')
    //       return false
    //     }
    //     var st = window.pageYOffset || document.documentElement.scrollTop // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
    //     if (st > lastScrollTop) {
    //       if ($('.search').hasClass('show')) {
    //         $('.search').removeClass('show')
    //       }
    //     } else {
    //       if (!$('.search').hasClass('show')) {
    //         $('.search').addClass('show')
    //       }
    //     }

    //     lastScrollTop = st <= 0 ? 0 : st // For Mobile or negative scrolling
    //   },
    //   false
    // )
    $('body').on('click', '.mb_search', () => {
      $('.search').toggleClass('show')
      $('.dropMenuBg').addClass('open search')
    })
  },
  passwordShow() {
    $('.eyes').on('click', function () {
      $(this).toggleClass('active')
      const pw_input = $(this).siblings('input')
      const current_type = pw_input.attr('type')
      if (current_type === 'password') {
        pw_input.attr('type', 'text')
      } else {
        pw_input.attr('type', 'password')
      }
    })
  },
  tabSwitch(
    tabClass,
    activeTabClassName,
    contentClass,
    activeContentClassName
  ) {
    $(`${tabClass}, ${contentClass}`).removeClass('active')
    $(`${activeTabClassName}, ${activeContentClassName}`).addClass('active')
  },
}

$('document').ready(() => {
  layoutJS.setLayout()
  layoutJS.mobileMenuHandler()
  layoutJS.mobileDetectDirect()
  layoutJS.passwordShow()
})
